import { FC, MouseEvent } from 'react';

import { ShareChannel } from '@shared/api/giftCoupon/giftCoupon.interface';
import { GiftDeliveryShareChannel } from '@shared/api/giftDelivery/giftDelivery.interface';

import { ShareChannelIcon } from './ShareChannelIcon';

interface Props {
  /** 표시 라벨 — '전달완료' / '미전달' / '확인됨' */
  label: string;
  /** 배경/텍스트 색상 클래스 (status 별로 다름) */
  styleClass: string;
  /** 마지막 공유 채널. 있으면 라벨 앞에 작은 아이콘 노출 */
  channel?: ShareChannel | GiftDeliveryShareChannel | null;
  /** 카카오톡 공유 채팅방 수. 0/undefined면 미노출 */
  kakaoCount?: number;
}

/**
 * 공유 상태를 한 덩어리로 표시하는 통합 뱃지.
 *
 * `[채널아이콘 라벨 카톡수]` 형태로 한 박스 안에 합쳐 시각적 밀도를 낮춘다.
 * 카톡수 부분만 클릭 가능하며, 누르면 안내 alert 가 뜬다.
 */
export const ShareStatusBadge: FC<Props> = ({
  label,
  styleClass,
  channel,
  kakaoCount,
}) => {
  const handleKakaoCountClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    alert(`현재 카카오톡 ${kakaoCount}개 채팅방에 전달된 상태입니다.`);
  };

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-xs font-medium ${styleClass}`}
    >
      {channel && <ShareChannelIcon channel={channel} className="h-4 w-4" />}
      <span className="break-keep">{label}</span>
      {!!kakaoCount && (
        <button
          type="button"
          onClick={handleKakaoCountClick}
          title={`카카오톡 ${kakaoCount}개 채팅방에 전달됨`}
          className="-mr-1 -my-0.5 ml-0.5 inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-kakao-yellow px-1 text-[11px] font-bold text-kakao-brown active:opacity-80"
        >
          {kakaoCount}
        </button>
      )}
    </span>
  );
};
